import { useEffect, useState } from 'react';
import { PayStateFormState } from 'routes/HumanResourcesModule/PayState/PayStateHome/components/PayStateModal/PayStateForm';

export function usePayStateFormState(
    initialState: PayStateFormState,
    editMode: boolean,
): [
    PayStateFormState,
    React.Dispatch<React.SetStateAction<PayStateFormState>>,
] {
    const [state, setState] = useState(initialState);
    const [isFormValid, setIsFormValid] = useState(false);

    useEffect(() => {
        if (state.title)
            setIsFormValid(
                editMode
                    ? true
                    : state.selectedOrgChartHrsSoftwareIds.length > 0,
            );
    }, [state.title, state.selectedOrgChartHrsSoftwareIds]);

    return [{ ...state, isFormValid }, setState];
}
